import React, { Component } from 'react';
import {toast } from 'react-toastify';
import cookie from 'react-cookies';
import $ from 'jquery';
import {updateValueInJson, esUrl, showModalPageClass, hideModalPageClass} from '../../../../../functions';
import axios from 'axios';
import {API_URL} from '../../../../../constants';
import ModalMultimedia from '../../../../Partials/ModalMultimedia';

export default class AdmRegulacionPais extends Component {

    constructor(props) {

        super(props); 

        this.state = { 
            modulo: this.props.modulo,
            resource:{
                pmod_Id:0,
                pagi_Id:this.props.pagina,
                mweb_Id:this.props.modulo.id,
                pmod_ClaseAncla:"",
                pmod_Sect_Id:0,
                pmod_Pweb_Id:0,

                mrpa_Titulo:"",
                mrpa_Enlace:"",
                mrpa_ArchivoAdjunto:"",
                mrpa_RequisitoArancelario:0,
                pais_Id:0,
                mrpa_Activo:true
            },
            resourceEdit:{
                pmod_Id:0,
                pmod_ClaseAncla:"",
                pmod_Sect_Id:0,
                pmod_Pweb_Id:0,

                mrpa_Id:0,
                mrpa_Titulo:"",
                mrpa_Enlace:"",
                mrpa_ArchivoAdjunto:"",
                mrpa_RequisitoArancelario:0,
                pais_Id:0,
                mrpa_Activo:true
            },
            Validacion: {
                mrpa_Titulo: {
                    Error: false,                    
                },
                mrpa_Enlace: {
                    Error: false,                    
                }
            },
            ValidacionEdit:{
                mrpa_Titulo: {
                    Error: false,                    
                },
                mrpa_Enlace: {
                    Error: false,                    
                }
            },
            perfiles: this.props.perfiles,
            sectores: this.props.sectores,
            paises: this.props.paises,
            hasError:false,
            added:false,
            confirmStore:false,
            security: cookie.load('user'),
            roles: [], 
            fieldReturnMultimedia:""
          }
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleInputChangeEdit = this.handleInputChangeEdit.bind(this);
        this.getResponseMultimedia = this.getResponseMultimedia.bind(this);
    }

    getResponseMultimedia = (urlSeleccionada) => {

        let resource = this.state.isEditfieldReturnMultimedia ? this.state.resourceEdit : this.state.resource;
        let fieldReturn = this.state.fieldReturnMultimedia;
    
        if(fieldReturn!== ""){
    
            resource[fieldReturn] = urlSeleccionada;
            
            if(this.state.isEditfieldReturnMultimedia){
                this.setState({resourceEdit:resource, fieldReturnMultimedia:"", isEditfieldReturnMultimedia:false});
            }else{
                this.setState({resource:resource, fieldReturnMultimedia:""});
            }
        }
    
        hideModalPageClass("divGestorArchivosRegPais");
    }
    
    showModalMultimedia = (clase = "", campo = "", isEdition = false) => {
        this.setState({fieldReturnMultimedia:campo, isEditfieldReturnMultimedia:isEdition});
        showModalPageClass(clase);
    }

    handleInputChange(event) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let copyResource = this.state.resource;
        copyResource[target.name] = value;

        let validaciones = this.state.Validacion;

        validaciones[target.name] = {
            Error: false,                    
        }

        this.setState({
            resource: copyResource,
            Validacion: validaciones
        });  
    }

    handleInputChangeEdit(event) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let copyResource = this.state.resourceEdit;
        copyResource[target.name] = value;

        let validaciones = this.state.ValidacionEdit;

        validaciones[target.name] = {
            Error: false,                    
        }

        this.setState({
            resourceEdit: copyResource,
            ValidacionEdit: validaciones
        });  
    }

    storeModulo = (e) => {

        if(e != undefined){
            e.preventDefault();
        }

        let newState = this.state;
        newState.hasError = false;

        if (newState.resource.mrpa_Titulo == '') {              
            newState.Validacion.mrpa_Titulo = {Error: true};
            newState.hasError = true;
        } 

        if (newState.resource.mrpa_Enlace !== '' && !esUrl(newState.resource.mrpa_Enlace)) {  
            newState.Validacion.mrpa_Enlace = {Error: true};
            newState.hasError = true;
        }

        if(newState.hasError){
            this.setState(newState);
            return;
        }

        const url = `${API_URL}ModuloRegulacionPaisUX/`;
        var dataForm = this.state.resource;
        dataForm = updateValueInJson(dataForm,'mrpa_UsuarioCreacion', this.state.security.nUsuCodigo);

        const formData = JSON.stringify(dataForm);

        axios.post(
        url, 
        JSON.stringify(formData),
        { headers: {
        'Content-Type': 'application/json; charset=UTF-8' ,
        'Accept': 'application/json'
        }
        }
        ).then(
        (data)=> {             
            
            if (data.data.isSucess)
            {
                let result = data.data.result;
                let stateResponse = this.state;

                stateResponse.added = true;

                stateResponse.resource.mrpa_Titulo = '';
                stateResponse.resource.mrpa_Enlace = '';
                stateResponse.resource.mrpa_ArchivoAdjunto = '';
                stateResponse.resource.mrpa_RequisitoArancelario = 0;
                stateResponse.resource.pais_Id = 0;

                stateResponse.resource.pmod_Id = result.pmod_Id;

                document.getElementById("pweb_Id").selectedIndex = 0;
                document.getElementById("pais_Id").selectedIndex = 0;
                document.getElementById("mrpa_RequisitoArancelario").selectedIndex = 0;

                this.setState(stateResponse);

                setTimeout(() => { 
                    this.setState({added:false});
                }, 3000); 

                this.props.callback(true);

                $(".divClosePopup_Modals").trigger("click");

            } else 
            {
                this.setState({hasErrorProceso:true});

                setTimeout(() => { 
                    this.setState({hasErrorProceso:false});
                }, 3000); 
            }
        }
        ).catch((error)=> {
        console.log('Error no controlado.');
        this.setState({loading:false});
        });        
    }

    updateModulo = (e) => {

        if(e != undefined){
            e.preventDefault();
        }

        let newState = this.state;
        newState.hasError = false;

        if (newState.resourceEdit.mrpa_Titulo == '') {              
            newState.ValidacionEdit.mrpa_Titulo = {Error: true};
            newState.hasError = true;
        }

        if (newState.resourceEdit.mrpa_Enlace !== '' && !esUrl(newState.resourceEdit.mrpa_Enlace)) {  
            newState.ValidacionEdit.mrpa_Enlace = {Error: true};
            newState.hasError = true;
        }

        if(newState.hasError){
            this.setState(newState);
            return;
        }

        const url = `${API_URL}ModuloRegulacionPaisUX/`;
        var dataForm = this.state.resourceEdit;
        dataForm = updateValueInJson(dataForm,'mrpa_UsuarioEdicion', this.state.security.nUsuCodigo);

        const formData = JSON.stringify(dataForm);

        axios.put(
        url, 
        JSON.stringify(formData),
        { headers: {
        'Content-Type': 'application/json; charset=UTF-8' ,
        'Accept': 'application/json'
        }
        }
        ).then(
        (data)=> {             
            
            if (data.data.isSucess)
            {
                this.setState({added:true});

                setTimeout(() => { 
                    this.setState({added:false});
                }, 3000); 
            
            } else 
            {
                this.setState({hasErrorProceso:true});

                setTimeout(() => { 
                    this.setState({hasErrorProceso:false});
                }, 3000); 
            }
        }
        ).catch((error)=> {
        console.log('Error no controlado.');
        this.setState({loading:false});
        });        
    }

    closeModulo = () => {

        let resource = this.state.resource;
        resource.pmod_Id = 0;
        
        let resourceEdit = this.state.resourceEdit;
        resourceEdit.mrpa_Id = 0;
        this.setState({resource:resource, resourceEdit:resourceEdit});

        this.props.callback(true);
        
    }    

    loadModulo = (pmod_Id) => 
    {
        const url = `${API_URL}ModuloRegulacionPaisUX/Seleccionar/${pmod_Id}`;

        axios.get(url).then(response => response.data)
        .then((data) => {
            
            this.setState({ resourceEdit: data.result, response: data, error: data.Error });           

        })
        .catch(error => {
            console.log("¡Error al inicializar!");
        });
    }    
    
    componentWillReceiveProps(nextProps){

        let mweb = 26;

        if(nextProps.pmodId !== this.state.resource.pmod_Id && mweb == nextProps.mWebEdit){
            let resource = this.state.resource;
            resource.pmod_Id = nextProps.pmodId;

            this.setState({resource: resource});

            setTimeout(() => { 
                this.loadModulo(resource.pmod_Id);
            }, 100); 
        }
      } 

    render() {

        let modulo = this.state.modulo;

        return (
            <div className="divModalBanner popUpGeneral" id={"modal_" + modulo.id} style={{display:"none"}}>
                <div className="divLayerPopup_ModalPaginas">
                    <div className="divPopup_ModalPaginas">
                    <div className="divClosePopup_Modals" onClick={() => this.closeModulo()}/>
                    <h2>{modulo.nombre} </h2>
                    <div className="divWrapperModalPaginas">

                        {
                            this.state.resourceEdit.mrpa_Id > 0 ?
                            <React.Fragment>
                            <div className="containerFormCreation divModuloPopup_Panel">
                                {
                                    this.state.added ?
                                    <div className="txtFile x-1">
                                        <strong style={{
                                            display: "block",
                                            textAlign:"center",
                                            color: "#008000a3"
                                        }}> Registro actualizado satisfactoriamente!!</strong>
                                    </div> : null
                                }
                                
                                <div className="txtFile x-1">
                                    <input type="text" placeholder="Título" 
                                    value={this.state.resourceEdit.mrpa_Titulo} 
                                    name="mrpa_Titulo"  
                                    className={this.state.ValidacionEdit.mrpa_Titulo.Error ? "error" : ""}
                                    onChange={this.handleInputChangeEdit} 
                                    maxLength={255} />
                                </div>

                                <div className="txtFile x-1">
                                    <input type="text" placeholder="Enlace" 
                                    value={this.state.resourceEdit.mrpa_Enlace} 
                                    name="mrpa_Enlace"  
                                    className={this.state.ValidacionEdit.mrpa_Enlace.Error ? "error" : ""}
                                    onChange={this.handleInputChangeEdit} 
                                    maxLength={500} />
                                </div>

                                <div className="txtFile x-1 relative">
                                    <span className="subirImagen" data-id="txtIconoCategoria" onClick={() => this.showModalMultimedia("divGestorArchivosRegPais", "mrpa_ArchivoAdjunto", true)}/>
                                    <input type="text" placeholder="Archivo" 
                                    value={this.state.resourceEdit.mrpa_ArchivoAdjunto} 
                                    name="mrpa_ArchivoAdjunto"  
                                    onChange={this.handleInputChangeEdit} 
                                    maxLength={1000} />
                                </div>

                                <div className="txtFile x-1">
                                    <select name='pais_Id' id='pais_Id' 
                                    onChange={this.handleInputChangeEdit} style={{display:"none"}}>
                                        <option value="0">Seleccionar País</option>
                                        {
                                            this.state.paises.length > 0 ?
                                            this.state.paises.map((pais) => (
                                                <option value={pais.id} key={pais.id} selected={(this.state.resourceEdit.pais_Id == pais.id) ? true : false}>{pais.nombre.toUpperCase()}</option>
                                            ))
                                            : null
                                        }
                                    </select>                        
                                </div>
                                

                                <div className="divModulo_Seo">
                                    <h2><strong>Configuración de modulo</strong></h2>
                                    <div className="divWrapperModulo_Seo">
                                        
                                        <div className="txtFile x-2">
                                            <input type="text" placeholder="Anclaje del modulo" name='pmod_ClaseAncla' value={this.state.resourceEdit.pmod_ClaseAncla}  
                                            onChange={this.handleInputChangeEdit}/>
                                        </div>	

                                        <div className="txtFile x-1">
                                            <select name='pmod_Pweb_Id' id='pmod_Pweb_Id' 
                                            onChange={this.handleInputChangeEdit} >
                                                <option value="0">Seleccionar Perfil</option>
                                                {
                                                    this.state.perfiles.length > 0 ?
                                                    this.state.perfiles.map((perfil) => (
                                                        <option value={perfil.id} selected={(this.state.resourceEdit.pmod_Pweb_Id == perfil.id) ? true : false}>{perfil.nombre.toUpperCase()}</option>
                                                    ))
                                                    : null
                                                }
                                            </select>                        
                                        </div>

                                        <div className="txtFile x-1 ocultarcms">
                                            <select name='pmod_Sect_Id' id='pmod_Sect_Id' 
                                            onChange={this.handleInputChangeEdit} >
                                                <option value="0">Seleccionar Sector</option>
                                                {
                                                    this.state.sectores.length > 0 ?
                                                    this.state.sectores.map((sector) => (
                                                        <option value={sector.id} selected={(this.state.resourceEdit.pmod_Sect_Id == sector.id) ? true : false}>{sector.nombre.toUpperCase()}</option>
                                                    ))
                                                    : null
                                                }
                                            </select>                        
                                        </div>
                                        
                                    </div>
                                </div>



                            </div>
                            <div>
                                <a href="" className="btnAgregarPagina noneEvent" id="btnActualizarPerfilador" onClick={(e) => this.updateModulo(e)}>ACTUALIZAR</a>
                                <br/>
                                <br/>
                                <br/>
                            </div>
                            </React.Fragment>
                            :
                            <React.Fragment>
                                <div className="containerFormCreation divModuloPopup_Panel">

                                    
                                    <div className="txtFile x-1">
                                        <input type="text" placeholder="Título" 
                                        value={this.state.resource.mrpa_Titulo} 
                                        name="mrpa_Titulo"  
                                        className={this.state.Validacion.mrpa_Titulo.Error ? "error" : ""}
                                        onChange={this.handleInputChange} 
                                        maxLength={255} />
                                    </div>

                                    <div className="txtFile x-1">
                                        <input type="text" placeholder="Enlace" 
                                        value={this.state.resource.mrpa_Enlace} 
                                        name="mrpa_Enlace"  
                                        className={this.state.Validacion.mrpa_Enlace.Error ? "error" : ""}
                                        onChange={this.handleInputChange} 
                                        maxLength={500} />
                                    </div>

                                    <div className="txtFile x-1 relative">
                                        <span className="subirImagen" data-id="txtIconoCategoria" onClick={() => this.showModalMultimedia("divGestorArchivosRegPais", "mrpa_ArchivoAdjunto")}/>
                                        <input type="text" placeholder="Archivo" 
                                        value={this.state.resource.mrpa_ArchivoAdjunto} 
                                        name="mrpa_ArchivoAdjunto"  
                                        onChange={this.handleInputChange} 
                                        maxLength={1000} />
                                    </div>

                                    <div className="txtFile x-1">
                                        <select name='pais_Id' id='pais_Id' 
                                        onChange={this.handleInputChange} style={{display:"none"}}>
                                            <option value="0">Seleccionar País</option>
                                            {
                                                this.state.paises.length > 0 ?
                                                this.state.paises.map((pais) => (
                                                    <option value={pais.id} key={pais.id} selected={(this.state.resource.pais_Id == pais.id) ? true : false}>{pais.nombre.toUpperCase()}</option>
                                                ))
                                                : null
                                            }
                                        </select>                        
                                    </div>



                                    <div className="divModulo_Seo">
                                        <h2><strong>Configuración de modulo</strong></h2>
                                        <div className="divWrapperModulo_Seo">
                                            
                                            <div className="txtFile x-2">
                                                <input type="text" placeholder="Anclaje del modulo" name='pmod_ClaseAncla' value={this.state.resource.pmod_ClaseAncla}  
                                                onChange={this.handleInputChange}/>
                                            </div>	

                                            <div className="txtFile x-1">
                                                <select name='pmod_Pweb_Id' id='pmod_Pweb_Id' 
                                                onChange={this.handleInputChange} >
                                                    <option value="0">Seleccionar Perfil</option>
                                                    {
                                                        this.state.perfiles.length > 0 ?
                                                        this.state.perfiles.map((perfil) => (
                                                            <option value={perfil.id} key={perfil.id}>{perfil.nombre.toUpperCase()}</option>
                                                        ))
                                                        : null
                                                    }
                                                </select>                        
                                            </div>

                                            <div className="txtFile x-1 ocultarcms">
                                                <select name='pmod_Sect_Id' id='pmod_Sect_Id' 
                                                onChange={this.handleInputChange} >
                                                    <option value="0">Seleccionar Sector</option>
                                                    {
                                                        this.state.sectores.length > 0 ?
                                                        this.state.sectores.map((sector) => (
                                                            <option value={sector.id} key={sector.id}>{sector.nombre.toUpperCase()}</option>
                                                        ))
                                                        : null
                                                    }
                                                </select>                        
                                            </div>
                                            
                                        </div>
                                    </div>






                                </div>
                                <div>
                                    <a href="" className="btnAgregarPagina noneEvent" id="btnGuardarPerfilador" onClick={(e) => this.storeModulo(e)}>GUARDAR</a>
                                    <br/>
                                    <br/>
                                    <br/>
                                </div>
                            </React.Fragment>
                        }
                        
                        

                    </div>
                    </div>
                </div>
                <ModalMultimedia class="divGestorArchivosRegPais" callback={this.getResponseMultimedia.bind(this)}/>
            </div>
        )
    }
}
